export default __webpack_public_path__ + "static/media/5.ccdd3ac9.jpg";